import React from "react";

import { object, arrayOf, func, number } from "prop-types";

import { Button } from "../../../../common/index";

const displayAddress = (address) =>
  address.formatted_address
    .filter((addressPart) => addressPart !== "")
    .join(", ");

const AddressSelectList = ({ addresses, onAddressSelect, selectedIndex }) => (
  <div>
    <div className="text-center my-1">
      <p>Please pick your address from the list below:</p>
    </div>
    <div style={{ maxHeight: 400, overflowY: "scroll" }}>
      <div className="text-left list-group">
        {addresses.map((address, index) => (
          <Button
            key={index}
            classes={`register_field list-group-item list-group-item-action ${
              selectedIndex === index ? "bg-info text-white" : ""
            }`}
            onClick={() => onAddressSelect(index)}
          >
            {displayAddress(address)}
          </Button>
        ))}
      </div>
    </div>
  </div>
);

AddressSelectList.propTypes = {
  addresses: arrayOf(object),
  onAddressSelect: func.isRequired,
  selectedIndex: number.isRequired,
};

export default AddressSelectList;
